<cp-base-card [customClass]="'!bg-white/60 !border !border-white'">
	<ng-content></ng-content>
</cp-base-card>
